import React from "react";
import {
  Card,
  Button,
  Typography,
  Space,
  Row,
  Col,
} from "antd";
import {
  SafetyOutlined,
  ReloadOutlined,
  LockOutlined,
  BookOutlined,
  ApiOutlined,
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

export default function Rescue() {
  return (
    <Row gutter={24}>
      {/* LEFT COLUMN */}
      <Col span={16}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* RESCUE */}
          <Card>
            <Title level={5}>RESCUE</Title>

            <Paragraph>
              The rescue system is a network based environment and can be used
              to fix issues preventing a regular boot. It is also useful to
              install custom Linux distributions that are not directly offered
              by us. You are able to mount the server’s hard drive inside the
              rescue system.
            </Paragraph>

            <Paragraph>
              After enabling the rescue system you need to reboot the server in
              the next <b>60 minutes</b> to activate it. After another reboot
              your server will boot from its local disk again.
            </Paragraph>

            <Space>
              <Button danger type="primary" icon={<SafetyOutlined />}>
                Enable rescue
              </Button>
              <Button danger icon={<ReloadOutlined />}>
                Enable rescue & power cycle
              </Button>
            </Space>
          </Card>

          {/* ROOT PASSWORD */}
          <Card>
            <Title level={5}>ROOT PASSWORD</Title>

            <Paragraph>
              This will set a new root password. If you removed the
              <Text strong> qemu-guest-agent </Text>
              from your server, this operation will fail.
            </Paragraph>

            <Button danger type="primary" icon={<LockOutlined />}>
              Reset Root Password
            </Button>
          </Card>
        </Space>
      </Col>

      {/* RIGHT COLUMN */}
      <Col span={8}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Card>
            <Title level={5}>HETZNER DOCS</Title>
            <Paragraph>
              Need more information? Maybe our Docs can help.
            </Paragraph>
            <Button icon={<BookOutlined />} block>
              Go to our Docs
            </Button>
          </Card>

          <Card>
            <Title level={5}>API DOCUMENTATION</Title>
            <Paragraph>
              Check out our full featured REST API and CLI client.
            </Paragraph>
            <Button icon={<ApiOutlined />} block>
              Go to API Docs
            </Button>
          </Card>
        </Space>
      </Col>
    </Row>
  );
}
